export const breakoutRoomInviteSchema = `
  id
  note
  invitationType
  status
  withoutTicket
  jobTitle
`;

export const statusEnum = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  CANCELED: 'canceled',
};

export const invitationTypesEnum = {
  VIP: 'vip',
  MODERATOR: 'moderator',
};
